export const sso = {
  error: {
    back: "Retour à la page de connexion",
    connectionError:
      "Une erreur est survenue lors de la connexion à la plateforme STELAR",
    userNotExist:
      "Le compte <span>{{ email }}</span> n’existe pas dans la plateforme STELAR. Pour créer votre compte, veuillez contacter le support",
    userDeactivated: "Votre compte est désactivé dans la plateforme STELAR",

    support: {
      message: "Pour contacter le support, cliquez sur ce lien",
      link: "Support",
    },
    title: "Erreur de connexion",
  },
};
